var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0C28.38 0 56.76 0 86 0C86 28.38 86 56.76 86 86C57.62 86 29.24 86 0 86C0 57.62 0 29.24 0 0ZM8 8C8 24.83 8 41.66 8 59C31.1 59 54.2 59 78 59C78 42.17 78 25.34 78 8C54.9 8 31.8 8 8 8Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4353 39.2705L17.625 50.0939C17.331 50.7551 17.8151 51.5 18.5388 51.5H69.0137C69.7236 51.5 70.2075 50.7808 69.9399 50.1232L59.1889 23.6936C58.8911 22.9613 57.9015 22.8479 57.4456 23.4937L47.2061 37.9998C46.8413 38.5165 46.0944 38.569 45.6609 38.1084L39.3252 31.3768C38.8963 30.921 38.1589 30.9668 37.7896 31.4721L29.6593 42.5977C29.3076 43.079 28.6156 43.1477 28.1762 42.7449L24.0249 38.9395C23.5211 38.4777 22.7129 38.646 22.4353 39.2705Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 23.5,
    r: 5.5,
    fill: "#757575"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 86,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.c5e40892c248addc98b2421d07909729.svg";
export { ForwardRef as ReactComponent };